import { onMounted, ref } from 'vue';
import { useApi } from '@/api/use-api';

/**
 * Хук для подготовки списка опций для выбора компетенций.
 * @property projectId - идентификатор проекта, для которого будет подготовлен список компетенций из компетенций
 * потфелей в которые входит этот проект.
 */
export function useCompetenceOptions(projectId) {
  const projectCompetencies = ref([]);
  const mainCompetencies = ref([]);
  const competenceOptions = ref([]);

  const api = useApi();

  onMounted(async () => {
    await fetchCompetenceOptions();
  });

  const update = async () => fetchMainCompetencies();

  const fetchCompetenceOptions = async () => {
    competenceOptions.value = [];
    await fetchProjectCompetencies();
    await fetchMainCompetencies();

    const projectCompetenceOptions = projectCompetencies.value.map((el) => ({
      value: el.name,
      ...el,
    }));
    const mainCompetenceOptions = mainCompetencies.value.map((el) => {
      return {
        value: el.name,
        ...el,
        disabled: projectCompetencies.value.some(
          (item) => item.name === el.name
        ),
      };
    });

    competenceOptions.value = [
      {
        label: 'Компетенции проекта',
        options: projectCompetenceOptions,
      },
      {
        label: 'Основные компетенции',
        options: mainCompetenceOptions,
      },
    ];
  };

  const fetchProjectCompetencies = async () => {
    try {
      const response = await api.competence.index(
        new URLSearchParams({
          projectId: projectId,
          'per-page': 100,
        })
      );
      projectCompetencies.value = response.competencies.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const fetchMainCompetencies = async () => {
    try {
      const response = await api.competence.index(
        new URLSearchParams({
          isMain: 1,
          'per-page': 100,
        })
      );
      mainCompetencies.value = response.competencies.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  return {
    competenceOptions,
    update,
  };
}
